export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const GET_PROFILE = "GET_PROFILE";
export const GET_PROFILES = "GET_PROFILES";
export const CLEAR_PROFILE = "CLEAR_PROFILE";
export const PROFILE_ERROR = "PROFILE_ERROR";
export const CREATE_PROFILE = "CREATE_PROFILE";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const ACCOUNT_DELETED = "ACCOUNT_DELETED";

export const ADD_TEAM_LEAD_INFO = "ADD_TEAM_LEAD_INFO";
export const ADD_TEAM_INFO = "ADD_TEAM_INFO";
export const TEAM_LEAD_ERROR = "TEAM_LEAD_ERROR";
export const TEAM_ERROR = "TEAM_ERROR";
export const MODULE_ERROR = "MODULE_ERROR";
export const ADD_MODULE = "ADD_MODULE";
